import { render, staticRenderFns } from "./SdsTableSection0.vue?vue&type=template&id=081f1d78"
import script from "./SdsTableSection0.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableSection0.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports